'use es6';

import getIn from 'transmute/getIn';
import { EMAIL_SUBJECT, TIMESTAMP, WORKFLOW_ID, RECIPIENT_VID } from '../constants/keyPaths';
export const getEmailSubject = getIn(EMAIL_SUBJECT);
export const getTimestamp = getIn(TIMESTAMP);
export const getWorkflowId = getIn(WORKFLOW_ID);
export const getRecipientVid = getIn(RECIPIENT_VID);